import '../ggs-clr'
import angular from 'angular'

export default angular
  .module('ggs.icons', [])
  .name
